import { render, staticRenderFns } from "./AuthorEdit.vue?vue&type=template&id=4fee3106"
import script from "./AuthorEdit.vue?vue&type=script&lang=js"
export * from "./AuthorEdit.vue?vue&type=script&lang=js"
import style0 from "./AuthorEdit.vue?vue&type=style&index=0&id=4fee3106&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports